module.exports = __webpack_public_path__ + "static/media/arrowRight.888c3e07.svg";